import React from 'react'
import { Block, Typography } from '@xprog/prensa'

const ReadMore = (props) => {
  const siteDomain = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG || 'opopular'

  const readMoreColor = (
    siteDomain.includes('cbn') ? '#D72027' :
      siteDomain.includes('tocantins') ? ' #164194' :
        siteDomain.includes('daqui') ? '#FC008F' :
          siteDomain.includes('opopular') ? '#164194 ' : '#164194'
  )

  const blockProps = {
    fontFamily: '$primary',
    mb: '25px',
    mt: '25px',
    width: '100%',
    '@lg': {
      backgroundColor: '#F7F7F7',
      pb: '8px'
    },
    '.p-readmore-box': {
      align: ['column', 'left', 'top'],
      borderLeft: `5px solid ${readMoreColor}`,
      'a': {
        color: readMoreColor,
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '21px',
        ml: '18px',
        mb: '18px',
        textDecoration: 'none'
      },
      '@lg': {
        borderLeft: 'none',
        'a': {
          fontSize: '22px',
          lineHeight: '35px',
          ml: '25px',
          mb: '18px',
          '&:hover': {
            textDecoration: 'underline',
          },
        }
      }
    }
  }

  const sectionTitleProps = {
    display: 'none',
    '@lg': {
      display: 'block',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '24px',
      ml: '25px',
      mt: '30px'
    }
  }

  return (
    <Block css={blockProps}>
      <Typography css={sectionTitleProps}>
        Leia Também
      </Typography>
      <div dangerouslySetInnerHTML={{ __html: props.content }} />
    </Block>
  )
}

export default ReadMore
